var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2229 4.20021L8.80715 0.207276C7.66479 -0.407791 6.2791 0.419909 6.2791 1.71711V16.5865C6.2791 16.8961 6.02794 17.1466 5.71898 17.1466H1.13951C0.510177 17.1466 0 17.6568 0 18.2861V18.8605C0 19.4898 0.510177 20 1.13951 20H14.2728C14.9022 20 15.4123 19.4898 15.4123 18.8605V18.2861C15.4123 17.6568 14.9022 17.1466 14.2728 17.1466H9.69336C9.38369 17.1466 9.13324 16.8954 9.13324 16.5865V10.4964L16.1287 7.2677C17.4124 6.67546 17.468 4.87094 16.2229 4.20021V4.20021ZM11.8233 6.11106L9.9431 6.97872C9.56493 7.15353 9.13253 6.87668 9.13253 6.45998V4.57981C9.13253 4.14813 9.59347 3.87199 9.9745 4.07677L11.8547 5.08928C12.2692 5.31261 12.2507 5.91341 11.8233 6.11034V6.11106Z",
    fill: "#89A0BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIcon2);
export default __webpack_public_path__ + "static/media/tab_icon_2.79e3855c1fd5cb3c300475a233a37cc0.svg";
export { ForwardRef as ReactComponent };